import { useCallback } from "react";
import { useLocation } from "react-router-dom";

const HEADER_HEIGHT_OFFSET = 55 as const;

const escapeSpecialCharacters = (str: string) => {
  return str.replace(/[/"'#@:.*+?^${}()|[\]\\-]/g, "\\$&");
};

export const useFocus = (ref: React.RefObject<HTMLElement>) => {
  const location = useLocation();
  const focus = useCallback(() => {
    const hash = location.hash.replace(/^#/, "");
    const decodedHash = decodeURIComponent(hash);
    // querySelectorで特殊文字が含まれている場合はエラーになるため、エスケープする
    const escapedHash = escapeSpecialCharacters(decodedHash);
    if (decodedHash && ref.current) {
      const element = ref.current.querySelector(`[id="${escapedHash}"]`);
      if (element) {
        // ヘッダーの高さ分だけスクロール位置をずらす
        const offset = HEADER_HEIGHT_OFFSET;
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
        ref.current.focus();
      }
    }
  }, [location.hash, ref]);
  return focus;
};
